import gql from 'graphql-tag';
import { companyFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const updateCompanyMutation = gql`
  mutation UpdateCompany($id: ID!, $input: UpdateCompanyInput!) {
    updateCompany(id: $id, input: $input) {
      ...AdminSanityDocumentFields
      ...AdminCompanyFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${companyFieldsFragment}
`;